const E = {
  'Back to Invoices': 'Back to Invoices',
  Cancel: 'Cancel',
  'Proceed with Payment': 'Proceed with Payment',
  footerDescription: 'By clicking Proceed with Payment, you agree to pay the listed invoice(s) using a the third party website.',
  'Invoice Total': 'Invoice Total',
  'Payment Amount': 'Payment Amount',
  'No Invoices are selected!': 'No Invoices are selected!',
  errorMessage: 'Opps! Something went wrong. You may have different currency invoices selected. Please contact Bureau Veritas technical support.',
  'Invoice #': 'Invoice #',
  'Balance Due': 'Balance Due',
  'PO #': 'PO #',
  'Project #': 'Project #',
  'Invoice Amount': 'Invoice Amount',
};

const F = {
  'Back to Invoices': 'Revenir aux factures',
  Cancel: 'Annuler',
  'Proceed with Payment': 'Procéder au paiement',
  footerDescription: 'En cliquant sur Procéder au paiement, vous acceptez de payer les factures indiquées via le site Web d’un tiers.',
  'Invoice Total': 'Total de la facture',
  'Payment Amount': 'Montant du paiement',
  'No Invoices are selected!': 'Aucune facture sélectionnée !',
  errorMessage: 'Il y a eu un problème ! Vous avez peut-être sélectionné des factures en devises différentes. Veuillez contacter le service technique des Laboratoires Bureau Veritas.',
  'Invoice #': 'No de facture',
  'Balance Due': 'Solde dû',
  'PO #': 'No de PO',
  'Project #': 'No de projet',
  'Invoice Amount': 'Montant de la facture',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/invoicesPaymentSummary.js